module.exports = __webpack_public_path__ + "static/assets/167d28ec0f80ad46794094b9b4444028.svg";